module.exports = __webpack_public_path__ + "static/media/Claremont Dr, San Bruno, CA4.a0c71f68.jpg";